import Subject from "../cse4sub/Subject";
import React from 'react'
import cse from '../assets/ECEASH305end21.pdf'
import csm from '../assets/ECEASH305mid21.pdf'


export default function Be() {
  return (
    <div>
       <Subject title="Basic Electronics(ASH305)" book1=" " book2=" "mid="Q. Paper"
    book1Link="#" book2Link="#" int21="#" mid21={csm} end21={cse}
     int20="#" mid20="#" end20="#"
    />
    </div>
  )
}